import { paths } from 'config/paths';
import { useRouter } from 'next/router';

import {
	SideNav,
	SideNavProps,
} from '~ui-components/components/molecules/side-nav';

export const dataUpdateNavItemKeys = {
	shapeFile: 'shapeFile',
	csvFile: 'csvFile',
	tabFile: 'tabFile',
};

export type DataUpdateSideNavProps = Omit<SideNavProps, 'navItems'>;

export function DatasetUpdateSideNav(): React.JSX.Element {
	const router = useRouter();

	const accountName = router.query['account-name'] as string;
	const datasetId = router.query['dataset-id'] as string;

	const navItems: SideNavProps['navItems'] = [
		{
			key: 'update-from-file',
			title: 'Update from file',
			items: [
				{
					key: 'shape',
					title: 'Shape',
					href: paths.accountName.data.datasetId.update.shape(
						accountName,
						datasetId
					),
				},
				{
					key: 'csv',
					title: 'CSV',
					href: paths.accountName.data.datasetId.update.csv(
						accountName,
						datasetId
					),
				},
				{
					key: 'tab',
					title: 'TAB',
					href: paths.accountName.data.datasetId.update.tab(
						accountName,
						datasetId
					),
				},
			],
		},
	];

	return <SideNav navItems={navItems} />;
}
